import React from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "../../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../../utils/text-constants/textConstants";
import EventEHRImageAvatar from "../../../../component-lib/Atoms/image-avatar/EventEHRImageAvatar";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    borderRadius: "8px",
    height: "436px",
    width: "708px",
    maxWidth: "none",
  },
}));

interface ViewMembersDialogProps {
  isOpen: boolean;
  dialogHeading: string;
  handleClose: () => void;
  viewData?: any;
}

const ViewMembersDialog = ({
  isOpen = false,
  viewData,
  handleClose,
  dialogHeading = "Your Heading Here...",
}: ViewMembersDialogProps) => {
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
    >
      <div className="flex justify-between items-center rounded-lg p-4">
        <Heading title={dialogHeading} />
        <div onClick={handleClose} className="">
          <CloseIcon className="cursor-pointer" />
        </div>
      </div>
      <DialogContent dividers>
        <div className="relative flex w-full flex-col rounded-lg border border-slate-200 bg-white shadow-sm">
          <nav className="flex min-w-[400px] flex-col gap-1 p-1.5">
            {viewData?.memebers?.map((data: any, index: number) => {
              const memberInfo = data?.users || data?.adminUser;
              const fullName =
                memberInfo?.firstName || memberInfo?.lastName
                  ? `${memberInfo?.firstName ?? ""} ${memberInfo?.lastName ?? ""}`.trim()
                  : "-";
              return (
                <div
                  key={index}
                  role="button"
                  className="text-slate-800 flex w-full items-center rounded-md p-3 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 cursor-default"
                >
                  <div className="mr-4 grid place-items-center">
                    <EventEHRImageAvatar
                      image={""}
                      commonStyle={{
                        marginRight: "16px",
                        width: "35px",
                        height: "35px",
                        border: "2px solid #BCBCBC",
                        borderRadius: "50%",
                        overflow: "auto",
                      }}
                      customTextStyle={{
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                      customImageStyle={{
                        borderRadius: "50%",
                      }}
                      labelText={fullName}
                    />
                  </div>
                  <div>
                    <h6 className="text-slate-800 font-medium">{fullName}</h6>
                    <p
                      className={` text-sm ${
                        data?.role === "Admin"
                          ? "text-red-500"
                          : "text-slate-500"
                      }`}
                    >
                      {data?.role === "Membare" ? "Member" : data?.role}
                    </p>
                  </div>
                </div>
              );
            })}
          </nav>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="p-2">
          <Button
            label={TEXT_CONSTANTS?.CLOSE}
            variant="contained"
            onClickCb={handleClose}
            style={{
              width: "120px",
              height: "44px",
              padding: "12px 20px",
              fontSize: "16px",
              marginRight: "6px",
            }}
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ViewMembersDialog;
